import { useState } from "react"
import { useTranslation } from "react-i18next"
import { motion, AnimatePresence } from "framer-motion"
import { Box } from "theme-ui"
import openIcon from "./selecticon.png"
import { TableRow } from "components"
export const StatusItem = ({ index, item }: any) => {
 // language translator
 const { t } = useTranslation("translation")

 const [mainIndex, setMainIndex] = useState<boolean | null>(true)
 const [subIndex, setSubIndex] = useState<boolean | null>(false)
 const [innerIndex, setInnerIndex] = useState<boolean | null>(false)

 return (
  <div key={index} className="w-full mx-0 px-2.5 lg:px-0 lg:mx-2 mb-5">
   <Box bg="highlight" className=" w-full py-3 rounded-t">
    <Box
     bg="gray"
     color="text-black"
     style={{ margin: "0 auto" }}
     className="flex justify-between items-center w-[96%] rounded mx-auto px-2 py-3"
     onClick={() => {
      setMainIndex(!mainIndex)
     }}
    >
     <h1>{t("deviceInformation")}</h1>
     <div
      onClick={() => setMainIndex(!mainIndex)}
      className="h-6 w-6 rounded bg-dark-yellow flex items-center justify-center cursor-pointer"
     >
      <img className={`${mainIndex ? "rotate-360" : "rotate-180"}`} src={openIcon} alt="icon" />
     </div>
    </Box>
    <div>
     <AnimatePresence>
      {mainIndex && (
       <div className="">
        <Box bg="highlight" color="text-black">
         <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={`border-b-[1.5px] border-light-gray w-full ${
           index === item?.device_info?.length - 1 ? "border-none pb-0" : ""
          }`}
         >
          <TableRow name={t("name")} value={item?.device_info.name} />
          <TableRow name={t("place")} value={item?.device_info.location} />
          <TableRow name={t("deviceType")} value={item?.device_info.device_type} />
          <TableRow name={t("deviceNumber")} value={item?.device_info.device_number} />
          <TableRow name={t("deviceGroup")} value={item?.device_info.device_group} />
          <TableRow name={t("timeAutomation")} value={item?.device_info.timeautomation} />
          <TableRow name={t("ptType")} value={item?.device_info.pt_type} />
          <TableRow name={t("manufacturer")} value={item?.device_info.manufacturer} />
          <TableRow
           name={t("controlUnit")}
           value={item?.device_info.control_unit}
           borderUnset={true}
          />
          <div></div>
         </motion.div>
        </Box>
       </div>
      )}
     </AnimatePresence>
    </div>
   </Box>
   <Box bg="highlight" className=" w-full py-3">
    <Box
     bg="gray"
     color="text-black"
     style={{ margin: "0 auto" }}
     onClick={() => {
      setSubIndex(!subIndex)
     }}
     className="flex justify-between items-center w-[96%] rounded mx-auto px-2 py-3"
    >
     <h1>{t("deviceStatusInformation")}</h1>
     <div
      onClick={() => setSubIndex(!subIndex)}
      className="h-6 w-6 rounded bg-dark-yellow flex items-center justify-center cursor-pointer"
     >
      <img className={`${subIndex ? "rotate-360" : "rotate-180"}`} src={openIcon} alt="icon" />
     </div>
    </Box>
    <div>
     <AnimatePresence>
      {subIndex && (
       <div className="">
        <Box bg="highlight" color="text-black">
         <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={`border-b-[1.5px] border-light-gray w-full ${
           index === item?.device_info?.length - 1 ? "border-none pb-0" : ""
          }`}
         >
          <TableRow name={t("status")} value={item?.device_status_information.status} />
          <TableRow
           name={t("communication")}
           value={item?.device_status_information.communication}
          />
          <TableRow name={t("deviceState")} value={item?.device_status_information.device_state} />
          <TableRow
           name={t("interferenceState")}
           value={item?.device_status_information.interference_state}
          />
          <TableRow name={"operatingMode"} value={item?.device_status_information.operating_mode} />
          <TableRow
           name={t("signalProgram")}
           value={item?.device_status_information.signal_program}
          />
          <TableRow name={"Last Change"} value={item?.device_status_information.last_change} />
          <TableRow
           name={t("trafficDependency")}
           value={item?.device_status_information.traffic_dependency}
          />
          <TableRow name={"Oepnv"} value={item?.device_status_information.oepnv} />
          <TableRow
           name={t("individualTraffic")}
           value={item?.device_status_information.individual_traffic}
           borderUnset={true}
          />
         </motion.div>
        </Box>
       </div>
      )}
     </AnimatePresence>
    </div>
   </Box>
   <Box bg="highlight" className=" w-full py-3 rounded-b mb-5">
    <Box
     bg="gray"
     color="text-black"
     style={{ margin: "0 auto" }}
     className="flex justify-between items-center w-[96%] rounded mx-auto px-2 py-3"
     onClick={() => {
      setInnerIndex(!innerIndex)
     }}
    >
     <h1>{t("deviceSettings")}</h1>
     <div
      onClick={() => setInnerIndex(!innerIndex)}
      className="h-6 w-6 rounded bg-dark-yellow flex items-center justify-center cursor-pointer"
     >
      <img className={`${innerIndex ? "rotate-360" : "rotate-180"}`} src={openIcon} alt="icon" />
     </div>
    </Box>
    <div>
     <AnimatePresence>
      {innerIndex && (
       <div className="">
        <Box bg="highlight" color="text-black">
         <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={`border-b-[1.5px] border-light-gray w-full ${
           index === item?.device_settings?.length - 1 ? "border-none pb-0" : ""
          }`}
         >
          <TableRow
           name={t("changingTimestamp")}
           value={item?.device_settings.changing_timestamp}
          />
          <TableRow name={t("timeSource")} value={item?.device_settings.time_source} />
          <TableRow name={t("energyOff")} value={item?.device_settings.energy_off} />
          <TableRow name={t("supplyPowerOk")} value={item?.device_settings.supply_power_ok} />
          <TableRow
           name={t("disturbedDetectors")}
           value={item?.device_settings.disturbed_detectors}
          />
          <TableRow name={t("disturbedLamps")} value={item?.device_settings.disturbed_lamps} />
          <TableRow
           name={"persistenceMemoryOk"}
           value={item?.device_settings.persistence_memory_ok}
           borderUnset={true}
          />
         </motion.div>
        </Box>
       </div>
      )}
     </AnimatePresence>
    </div>
   </Box>
  </div>
 )
}
